export const QUERY_KEYS = {
  PLACEMENT_TYPES: 'placementTypes',
  PLACEMENT_PROPERTIES: 'placementProperties',
  COMPLEX: 'complex',
  DISPLAY_PLACEMENT_DATA: 'displayPlacementData',
  TILE: 'tile',
  MANAGE_USERS_INITIAL: 'manageUsersInitial',
  CREATE_USER_INITIAL: 'createUserInitial',
  MANAGE_USERS: 'manageUsers',
  COMPLEX_USERS: 'complexUsers',
  PLACEMENT_POPUP_CARD: 'placementPopupCard',
} as const;
